/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { requestSubscription, graphql } from 'react-relay';

import { ConnectionHandler } from 'relay-runtime';

import environment from '../RelayEnv';

const subscription = graphql`
  subscription MessageSentSubscription {
    messageSent {
      node {
        id
        ...Message_message
        channel {
          id
        }
      }
    }
  }
`;

const subscribe = function(channelID, viewerID, options) {
  if (options == null) {
    options = {};
  }
  return requestSubscription(environment, {
    subscription,
    variables: {},
    updater: store => {
      let channelProxy, conn, newEdge;
      const payload = store.getRootField('messageSent');
      console.log('payload', payload);
      const node = payload.getLinkedRecord('node');
      const messageId = node.getValue('id');

      // Helper function to check if message already exists in a connection
      const messageExistsInConnection = connection => {
        if (!connection) return false;
        const edges = connection.getLinkedRecords('edges');
        if (!edges) return false;
        return edges.some(edge => {
          const edgeNode = edge && edge.getLinkedRecord('node');
          return edgeNode && edgeNode.getValue('id') === messageId;
        });
      };

      const channel = node.getLinkedRecord('channel');
      if (channel != null) {
        channelProxy = store.get(channel.getValue('id'));
        conn = ConnectionHandler.getConnection(
          channelProxy,
          'Messages_messages',
        );
        if (conn != null && !messageExistsInConnection(conn)) {
          newEdge = ConnectionHandler.createEdge(
            store,
            conn,
            node,
            'MessageEgde',
          );
          ConnectionHandler.insertEdgeBefore(conn, newEdge);
        } else if (messageExistsInConnection(conn)) {
          console.log(
            'Message already in channel connection, skipping:',
            messageId,
          );
        }
      }

      channelProxy = store.get(viewerID);
      conn = ConnectionHandler.getConnection(
        channelProxy,
        'UserMessages_messages',
      );
      if (conn != null && !messageExistsInConnection(conn)) {
        newEdge = ConnectionHandler.createEdge(
          store,
          conn,
          node,
          'MessageEgde',
        );
        ConnectionHandler.insertEdgeBefore(conn, newEdge);
      } else if (messageExistsInConnection(conn)) {
        console.log('Message already in user connection, skipping:', messageId);
      }
    },
    onNext: resp => {},
    ...options,
  });
};

export default { subscribe };
